import { AddressInterface, PeriodsInterface } from 'common/address.interface';
import { TaxInterface } from '../tax/types';

/*
 * Action Types
 */
export enum SchoolsTypes {
  LIST_SCHOOLS_REQUEST = '@schools/LIST_SCHOOLS_REQUEST',
  LIST_SCHOOLS_SUCCESS = '@schools/LIST_SCHOOLS_SUCCESS',
  LIST_SCHOOLS_FAILURE = '@schools/LIST_SCHOOLS_FAILURE',

  GET_SCHOOL_REQUEST = '@schools/GET_SCHOOL_REQUEST',
  GET_SCHOOL_SUCCESS = '@schools/GET_SCHOOL_SUCCESS',
  GET_SCHOOL_FAILURE = '@schools/GET_SCHOOL_FAILURE',

  FILTER_SCHOOLS_REQUEST = '@schools/FILTER_SCHOOLS_REQUEST',
  FILTER_SCHOOLS_SUCCESS = '@schools/FILTER_SCHOOLS_SUCCESS',
  FILTER_SCHOOLS_FAILURE = '@schools/FILTER_SCHOOLS_FAILURE',

  CREATE_SCHOOL_REQUEST = '@schools/CREATE_SCHOOL_REQUEST',
  CREATE_SCHOOL_SUCCESS = '@schools/CREATE_SCHOOL_SUCCESS',
  CREATE_SCHOOL_FAILURE = '@schools/CREATE_SCHOOL_FAILURE',

  UPDATE_SCHOOL_REQUEST = '@schools/UPDATE_SCHOOL_REQUEST',
  UPDATE_SCHOOL_SUCCESS = '@schools/UPDATE_SCHOOL_SUCCESS',
  UPDATE_SCHOOL_FAILURE = '@schools/UPDATE_SCHOOL_FAILURE',

  UPDATE_SCHOOL_REPORT_LIMIT_REQUEST = '@schools/UPDATE_SCHOOL_REPORT_LIMIT_REQUEST',
  UPDATE_SCHOOL_REPORT_LIMIT_SUCCESS = '@schools/UPDATE_SCHOOL_REPORT_LIMIT_SUCCESS',
  UPDATE_SCHOOL_REPORT_LIMIT_FAILURE = '@schools/UPDATE_SCHOOL_REPORT_LIMIT_FAILURE',

  DELETE_SCHOOL_REQUEST = '@schools/DELETE_SCHOOL_REQUEST',
  DELETE_SCHOOL_SUCCESS = '@schools/DELETE_SCHOOL_SUCCESS',
  DELETE_SCHOOL_FAILURE = '@schools/DELETE_SCHOOL_FAILURE',

  LIST_COURSES_REQUEST = '@schools/LIST_COURSES_REQUEST',
  LIST_COURSES_SUCCESS = '@schools/LIST_COURSES_SUCCESS',
  LIST_COURSES_FAILURE = '@schools/LIST_COURSES_FAILURE',

  CREATE_COURSE_REQUEST = '@schools/CREATE_COURSE_REQUEST',
  CREATE_COURSE_SUCCESS = '@schools/CREATE_COURSE_SUCCESS',
  CREATE_COURSE_FAILURE = '@schools/CREATE_COURSE_FAILURE',

  UPDATE_COURSE_REQUEST = '@schools/UPDATE_COURSE_REQUEST',
  UPDATE_COURSE_SUCCESS = '@schools/UPDATE_COURSE_SUCCESS',
  UPDATE_COURSE_FAILURE = '@schools/UPDATE_COURSE_FAILURE',

  DELETE_COURSE_REQUEST = '@schools/DELETE_COURSE_REQUEST',
  DELETE_COURSE_SUCCESS = '@schools/DELETE_COURSE_SUCCESS',
  DELETE_COURSE_FAILURE = '@schools/DELETE_COURSE_FAILURE',

  FILTER_COURSES_REQUEST = '@schools/FILTER_COURSES_REQUEST',
  FILTER_COURSES_SUCCESS = '@schools/FILTER_COURSES_SUCCESS',
  FILTER_COURSES_FAILURE = '@schools/FILTER_COURSES_FAILURE',
}

/*
 * Data types
 */

export interface SchoolSettings {
  id: string;
  paymentType: number;
  releaseType: number | null;
  creditExpirationLink: boolean;
  creditExpirationDays: number | null;
  creditExpirationDate?: number | null;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId?: string;
  SchoolSettingsSchool?: SchoolSettings;
  schoolSettingsId?: string;
  schoolId?: string;
}

export interface SchoolReportLimit {
  allowedChecks: number;
  consumedChecks: number;
  renewDay: number;
}

export interface SchoolInterface {
  id: string;
  name: string;
  code: string;
  document: string;
  phone: string;
  email: string;
  status: number;
  type: number;
  mec: boolean;
  createdAt: string;
  updatedAt: string;
  allowedChecks?: number;
  renewDay?: number;
  Taxes?: TaxInterface[];
  Addresses?: AddressInterface[];
  SchoolPeriods?: PeriodsInterface[];
  SchoolTimings?: PeriodsInterface[];
  SchoolSettings?: SchoolSettings[];
  SchoolReportLimit?: SchoolReportLimit;
}
export interface CourseInterface {
  name: string;
  id: string;
}
export interface SchoolCourseInterface {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  schoolId: string;
}

/*
 * State type
 */
export interface SchoolsState {
  readonly schoolsList: SchoolInterface[];
  readonly schoolsListFull: SchoolInterface[];
  readonly schoolData: SchoolInterface;
  readonly coursesList: SchoolCourseInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
